/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-04 11:12:47
 * @LastEditors: jikeychang@gmail.com
 * @LastEditTime: 2021-03-04 11:14:52
 * @Description: FileDescription
 */
/*
 * @Description: ums-用户管理系统-组织管理store
 * @Author: jikeyChang
 * @Date: 2019-08-26 16:18:31
 * @LastEditTime: 2019-08-26 17:05:00
 * @LastEditors: Please set LastEditors
 */

import dbDepartmentBudget from '@/api/organizeManage';

export default {
  namespaced: true,

  state: {
    /**
     * 预算部门
     */
    budgetDepartmentList: [], // 预算部门List
    treeParentNode: [], // 预算部门父节点
    budgetDepartmentDtlData: [], // 预算部门详细
    selectUserList: [],
    usersTreeData: [], // userTrees
    usersTreeParentData: [],
    usersTreeChildData: [],
  },
  actions: {
    /**
     * 预算部门
     */
    // 获取:预算部门树
    getBudgetDepartmentList({ commit }, param) {
      return dbDepartmentBudget.getBudgetDepartmentList(param).then((prod) => {
        commit('setBudgetDepartmentList', prod);
        // dispatch('getUsersTree', {});
      });
    },
    // 详情:预算部门树
    dtlBudgetDepartment({ commit }, param) {
      return dbDepartmentBudget.dtlBudgetDepartment(param).then((prod) => {
        commit('setBudgetDepDetailData', prod);
      });
    },
    // 删除:预算部门树
    delBudgetDepartment(store, param) {
      return dbDepartmentBudget.delBudgetDepartment(param).then(prod => prod);
    },
    // 新增:预算部门树
    addBudgetDepartment(store, param) {
      return dbDepartmentBudget.addBudgetDepartment(param).then(prod => prod);
    },
    // 编辑:预算部门树
    editBudgetDepartment(store, param) {
      return dbDepartmentBudget.editBudgetDepartment(param).then(prod => prod);
    },
    // 获取:user
    getUserList(store, param) {
      return dbDepartmentBudget.getUserList(param).then(prod => prod);
    },
    // // 获取:已选择user
    // getSelectUserList({ commit }, param) {
    //   return dbDepartmentBudget.getSelectUserList({ id: param }).then((prod) => {
    //     commit('setSelectUserList', prod);
    //   });
    // },
    // 获取：usersTree
    // getUsersTree({ commit }, param) {
    //   return dbDepartmentBudget.getUsersTree(param)
    //     .then((prod) => {
    //       commit('setUsersTreeData', prod);
    //     });
    // },
    // 获取：usersTreeChild
    getUsersTreeChild({ commit }, param) {
      return dbDepartmentBudget.getUsersTreeChild(param)
        .then((prod) => {
          commit('setUsersTreeChildData', prod);
        });
    },
  },
  mutations: {
    /**
     * 预算部门
     */
    setBudgetDepartmentList(state, content) {
      const listData = content.list;
      const newTreeData2 = listData.map((item) => {
        if (item.status === '1') {
          // item.selectable = false;
          item.class = 'lock';
        }
        item.scopedSlots = { title: 'title' };
        return item;
      });
      const treeData = JSON.parse(JSON.stringify(newTreeData2).replace(/id/g, 'key'));
      const treeData2 = JSON.parse(JSON.stringify(treeData).replace(/name/g, 'title'));
      state.budgetDepartmentList = treeData2;
      const parentNode = state.budgetDepartmentList.filter(item => item.parentId === null);
      state.treeParentNode = parentNode.map(item => item.key);
    },
    setUsersTreeData(state, content) {
      state.usersTreeParentData = content.list;
      state.usersTreeData = content.list;
    },
    setUsersTreeChildData(state, content) {
      state.usersTreeData = [];
      const { list } = content;
      state.usersTreeChildData = content.list;
      state.usersTreeData = [...state.usersTreeParentData, ...list];
    },
    setBudgetDepDetailData(state, content) {
      state.budgetDepartmentDtlData = content.data;
    },
    setSelectUserList(state, content) {
      state.selectUserList = content.list;
    },
  },
};
